import instance from '../utils/axios';

class BarcodeService {

    async getBarcodeFieldList(){
        return await instance.post('/erp/barcode/getBarcodeFields');
    }

    async getInputList(pageIndex, barcodeIds, dictNames) {
        return await instance.post('/erp/barcode/getStorageList', {
            barcodeIds: barcodeIds,
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'inputTime',
            sort: 'desc',
			dictionaryNames: dictNames
        });
    }
    async getReadyOutBarcode(pageIndex,outputId,dictNames,tableName) {
        return await instance.post('/erp/barcode/getReadyOutBarcode', {
            pageSize: 10,
            outputId:outputId,
            tableName:tableName || "",
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'inputTime',
            sort: 'desc',
			dictionaryNames: dictNames
        });
    }
    async getAlreadyOutBarcode(pageIndex,outputId,dictNames, tableName) {
        return await instance.post('/erp/barcode/getAlreadyOutBarcode', {
            pageSize: 10,
            outputId:outputId,
            tableName:tableName || "",
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'outputTime',
            sort: 'desc',
			dictionaryNames: dictNames
        });
    }
    async getOutputList(pageIndex, keyword) {
        return await instance.post('/erp/radOut/getList', {
            listFilter: " st.outQuantities>0",
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_serialNumber: keyword,
            searchField_string_contractNumber: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
			dictionaryNames: 'dealerId.rad_dealer,radId.rad_sku,radCategory.rad_sku_category,centerCategory.dict_rad_center_category,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method'
        });
    }

    async getBackupApplicationList(pageIndex, keyword) {
        return await instance.post('/erp/radOut/getBackupApplicationList', {
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_serialNumber: keyword,
            searchField_string_contractNumber: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
            dictionaryNames: 'dealerId.rad_dealer,radId.rad_sku,radCategory.rad_sku_category,centerCategory.dict_rad_center_category,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method'
        });
    }

    async getScanningOutputList(pageIndex, keyword) {
        return await instance.post('/erp/radOut/getScanningOutList', {
            pageSize: 10,
            pageIndex: pageIndex,
            fuzzySearch: keyword,
            searchField_string_serialNumber: keyword,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
            dictionaryNames: 'creatorId.base_staff'
        });
    }

    async insertScanningOutput(outputIds){
        return await instance.post('/erp/radOut/insertScanningOut',{outputIds:outputIds});
    }

    async getScanningOutput(scanningOutputId){
        return await instance.post('/erp/radOut/getScanningOut',{scanningOutputId:scanningOutputId});
    }

    async getPositionById(positionId){
        return await instance.post('/erp/barcode/getPositionById',{positionId:positionId});
    }

    async storage (barcode, position){
        return await instance.post('/erp/barcode/storage',{barcode:barcode, position: position});
    }

    async cancelStatus (barcode, cancelType){
        return await instance.post('/erp/barcode/cancelStatus',{barcode:barcode, cancelType: cancelType});
    }

    async storageChange (barcode, position){
        return await instance.post('/erp/barcode/storageChange',{barcode:barcode, position: position});
    }

    async outOfStock (barcode,outputId){
        return await instance.post('/erp/barcode/outOfStock',{barcode:barcode,outputId:outputId});
    }

    async fetchOutBarcode (barcode, orderId){
        return await instance.post('/erp/barcode/fetchOut',{barcode:barcode, orderId: orderId});
    }

    async discardBarcode (barcode){
        return await instance.post('/erp/barcode/discardOut',{barcode:barcode});
    }

    async barcodeReceiptOut (barcode,outputId,orderId){
        return await instance.post('/erp/barcode/receiptOut',{barcode:barcode,outputId:outputId,orderId:orderId});
    }

    async getOutputInfo (uuid){
        return await instance.get('/erp/radOut/getOutputInfo?uuid='+uuid);
    }

    async getOutOfStockDetail(uuid, dictNames, tableName){
        return await instance.post('/erp/radOut/getOutOfStockDetail', {
            pageSize: 0,
            pageIndex: 0,
            outputId: uuid,
            tableName: tableName || "",
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
			dictionaryNames: dictNames
        });
    }

    async getStockTakingList(pageIndex) {
        return await instance.post('/erp/barcode/stocktaking/list', {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc',
            dictionaryNames: 'creatorId.base_staff,status.rad_stock_taking_status'
        });
    }
	
	async getFreightList(pageIndex) {
		return await instance.post('/crm/script/getFreightList', {
			pageSize: 10,
			pageIndex: pageIndex,
			expressions: '[{"field": "数量", "expression": "count(1)"}]',
			sortField: 'createTime',
			sort: 'desc',
			dictionaryNames: '司机.base_staff,出车地点.dict_出车地点,到达地点.dict_到达地点'
		});
	}

	async getFreightDetail(formId) {
		return await instance.post('/crm/script/getFreightDetail', {formId: formId});
	}
	async saveForm(data) {
		return await instance.post('/wf/formMobile/saveData',
		{data: JSON.stringify(data),workflowTemplateId:'cfd04351190e4555a18a24b4a0b50fb9',details:JSON.stringify([])});
	}
	async submitForm(formId) {
		return await instance.post('/wf/form/vsheet/submit',
		{id:formId,name:'运输费用明细'});
	}
	async rejectForm(workflowId,type) {
		return await instance.post('/wf/form/vsheet/Audit',
		{workflowId:workflowId,type:type,opinion:'否决'});
	}
	async getfileList(attachIds){
		return await instance.post('/oa/common/attachment/indexVsheet',
		{attachIds:attachIds});
	}
	async passForm(workflowId,type) {
		return await instance.post('/wf/form/vsheet/Audit',
		{workflowId:workflowId,type:type,opinion:'无意见'
		// ,auditorIds:'3c3b16d86aab49e5a9de61c620d08341',
		});
	}
    async saveBarcodeStocktakingDetail(barcode, position, stockTakingId){
        return await instance.post('/erp/barcode/stocktaking/saveStockTaking',{barcode:barcode, position: position, stockTakingId: stockTakingId});
    }

    async getStockTakingDetailList(pageIndex, stockTakingId, type) {
        return await instance.post('/erp/barcode/stocktaking/detailList?stockTakingId='+stockTakingId+"&type="+type, {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'lastUpdateTime',
            sort: 'desc',
            dictionaryNames: 'type.rad_stock_taking_result'
        });
    }

    async deleteStockTakingDetail(stockTakingDetailId){
        return await instance.post('/erp/barcode/stocktaking/deleteDetail',{stockTakingDetailId: stockTakingDetailId});
    }

    async completeStockTaking(stockTakingId){
        return await instance.post('/erp/barcode/stocktaking/complete',{stockTakingId: stockTakingId});
    }

    async getStockTakingResult(stockTakingId){
        return await instance.post('/erp/barcode/stocktaking/getResult',{stockTakingId: stockTakingId});
    }

    async updateStockTakingStatus(stockTakingId){
        return await instance.post('/erp/barcode/stocktaking/updateStatus',{stockTakingId: stockTakingId});
    }
}
export default new BarcodeService();